import React, { Children } from 'react';
import * as ReactModal from 'react-modal';

import Colors from '../../config/Colors';

const customStyles = {
    content: {
        padding: 0,
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 8,
        overflow: 'visible'
    },
    overlay: {
        zIndex: 10,
        backgroundColor: Colors.darkerTransparent
    }
};

export const Modal = ({ children, ...props }) => {
    const shouldClose = () => setIsOpen(false);
    const { setIsOpen, isOpen } = props;

    const childrenWithProps = Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { ...props });
        }
        return child;
    });

    return (
        <ReactModal
            id={'modal'}
            ariaHideApp={false}
            isOpen={isOpen}
            style={customStyles}
            onRequestClose={shouldClose}
            bodyOpenClassName={'ReactModal_opened'}
            contentLabel="Modal"
        >
            {childrenWithProps}
        </ReactModal>
    );
};
